var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Close_svg__Layer_1",
    viewBox: "0 0 8 8",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Close_svg__cls-1{fill:none;stroke:currentColor;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_svg__Group_178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Close_svg__Line_32",
    d: "m1 7 6-6",
    className: "Close_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Close_svg__Line_33",
    d: "M7 7 1 1",
    className: "Close_svg__cls-1"
  }))));
};
export default SvgClose;